

import {Component, OnInit} from '@angular/core';
import { AuthService } from './auth/auth.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
      public auth: AuthService,
      private route: ActivatedRoute
      ) {
    auth.handleAuthentication();
    auth.scheduleRenewal();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        localStorage.setItem('access_token', token);
        sessionStorage.setItem('arrivedWithToken', 'true');
        localStorage.setItem('expires_at', `${Date.now() + 3600000}`);
        //window.location.href = 'smart-city-profile/Brazil-Sao-Paulo-Sao-Caetano-do-Sul/5d1cd6df628a9e05c7f9b1d0';
      }
    });
  }
}
